import { UPDATE_BASKET_DETAILS_SUCCESS, ANALYTICS_CONVERSION } from '@store/basket/actions';
import { dataLayerPush } from '@utils/tracking';

import { generateAnalyticsOrder, formatDatesAndPrices } from './utils';

const trackingActionMap = {
  [ANALYTICS_CONVERSION]: 'orderComplete',
  [UPDATE_BASKET_DETAILS_SUCCESS]: 'basketUpdated',
};

export const reducers = (state = {}, action: { type: string; payload: any }) => {
  const { payload, type } = action;
  switch (type) {
    case ANALYTICS_CONVERSION: {
      if (payload) {
        dataLayerPush({
          event: trackingActionMap[ANALYTICS_CONVERSION],
          data: formatDatesAndPrices(payload),
          ecommerce: generateAnalyticsOrder(formatDatesAndPrices(payload)),
        });
      }
      return state;
    }
    default:
      return state;
  }
};
